import Endpoint from './endpoint'
import { API_URL } from './index'

export default class Emails extends Endpoint {
  constructor(api) {
    super(api)
    this.cancel = () => {}
  }

  async preview(subject, body, resourceType, resourceId) {
    let url = new URL(`/api/emails/preview/${resourceType}/${resourceId}`, API_URL)

    // cancel previous promise
    this.cancel(new Error('PromiseCancelled'))

    const cancelPromise = new Promise((resolve, reject) => {
      this.cancel = reject
    })

    const requestPromise = this.request(url, {
      method: 'POST',
      body: JSON.stringify({
        subject,
        body
      })
    }, false) // don't track loading so global spinner won't show

    return Promise.race([cancelPromise, requestPromise])
  }
}
